// export const POS_LAYOUTS = {
//   MODERN: "modern",
//   CLASSICAL: "classical",
//   MODERN_V2: "modernV2",
// };

// export const getActivePOSLayout = ({ user }) => {
//   const permissions = user?.permissions || {};

//   if (permissions?.isClassicalPOSLayout === true) {
//     return POS_LAYOUTS.CLASSICAL;
//   }

//   if (permissions?.isModernV2POSLayout === true) {
//     return POS_LAYOUTS.MODERN_V2;
//   }

//   return POS_LAYOUTS.CLASSICAL;
// };

export const POS_LAYOUTS = {
  MODERN: "modern",
  MODERNV2: "modernv2",
  CLASSICAL: "classical",
};

export const POS_LAYOUT_VALUES = Object.values(POS_LAYOUTS);

export const getActivePOSLayout = ({ user }) => {
  const posLayout = user?.posLayout;

  if (POS_LAYOUT_VALUES.includes(posLayout)) {
    return posLayout;
  }

  return POS_LAYOUTS.MODERN;
};

export const isDirectAddOrderLayout = (user) => [POS_LAYOUTS.CLASSICAL, POS_LAYOUTS.MODERNV2].includes(user?.posLayout);